import clsx from 'clsx';
import { ReactNode } from 'react';

export default function Card({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={clsx('w-full p-[32px] bg-white shadow-card rounded-[12px]', className)}>
      {children}
    </div>
  );
}
